<template>
  <LoginLayout></LoginLayout>
</template>
<script>
import LoginLayout from '../../layouts/LoginLayout';

export default {
  name: 'Login',
  components: {
    LoginLayout
  }
};
</script>
<style>
@import '../../styles/login.css';
</style>
